import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'
import EducationApi from '@/api/education'
import TestApi from '@/api/test'

/* eslint-disable no-param-reassign */

// Безопасное помещение элементов по массиву
function arrayMove(arr, oldIndex, newIndex) {
  while (oldIndex < 0) {
    oldIndex += arr.length
  }
  while (newIndex < 0) {
    newIndex += arr.length
  }
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1
    // eslint-disable-next-line no-plusplus
    while (k--) {
      arr.push(undefined)
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
  return arr
}

function getTemporaryId() {
  return Math.floor(Math.random() * 1000000000)
}

function getEmptyCourseState() {
  return {
    courseContent: null,
    courseAvatar: null,
    subsection: null,
    progress: 0,
    marks: [],
    variants: [],
    subsectionIds: {
      topicInternalId: null,
      sectionInternalId: null,
      subsectionInternalId: null
    },
    isTestCreationMode: false,
    newTestTasks: [],
    courseChanges: {
      topicsToDelete: [],
      sectionsToDelete: [],
      subsectionsToDelete: []
    },
    courseSubsectionsStructure: {
      infos: [],
      tasks: []
    },
    testContent: null,
    subSectionHashes: {}
  }
}

export default {
  state: {
    courses: [],
    coursePagination: {
      pages: 0,
      total: 0
    },
    ...getEmptyCourseState()
  },
  mutations: {
    [MUTATION_TYPE.setCourseContent]: (state, courseContent) => {
      if (courseContent.topics) {
        state.courseSubsectionsStructure.infos = []
        state.courseSubsectionsStructure.tasks = []
        courseContent.topics
          .filter((t) => t.title !== 'Тестирование')
          .forEach((t) => {
            const { sections } = t
            if (sections) {
              sections.forEach((s) => {
                const subsections = s.subSections
                if (subsections) {
                  subsections.forEach((ss) => {
                    if (ss.type.includes('test')) {
                      state.courseSubsectionsStructure.tasks.push(ss.id)
                    } else {
                      state.courseSubsectionsStructure.infos.push(ss.id)
                    }
                  })
                }
              })
            }
          })
      }
      state.courseContent = courseContent
    },
    [MUTATION_TYPE.setCourseProgress]: (state, progress) => {
      state.progress = progress
    },
    [MUTATION_TYPE.addFileToSubsection]: (state, file) => {
      state.subsection.file = file
    },
    [MUTATION_TYPE.clearCourseContent]: (state) => {
      Object.assign(state, getEmptyCourseState())
    },
    [MUTATION_TYPE.updateCourseContent]: (state, contentObject) => {
      state.courseContent.contentObject = {
        ...state.courseContent.contentObject,
        ...contentObject
      }
    },
    [MUTATION_TYPE.updateCourseStatus]: (state) => {
      if (state.courseContent.contentObject.status === 'отклонено') {
        state.courseContent.contentObject.status = 'черновик'
      }
    },
    [MUTATION_TYPE.sortTests]: (state, organizationId) => {
      const testTopic = state.courseContent.topics[state.courseContent.topics.length - 1]
      const createdByCM = testTopic.sections.filter((p) => !p.isCreatedByTeacher)
      const createdByTeacher = testTopic.sections.filter(
        (p) => p.isCreatedByTeacher && p.organizationId === organizationId,
      )
      testTopic.sections = [...createdByCM, ...createdByTeacher]
    },
    [MUTATION_TYPE.setCourseTopics]: (state, topics) => {
      state.courseContent.topcs = topics
    },
    [MUTATION_TYPE.setCourses]: (state, courses) => {
      state.courses = courses
    },
    [MUTATION_TYPE.setScormCourses]: (state, courses) => {
      state.scormCourses = courses
    },
    [MUTATION_TYPE.setCoursesPagination]: (state, { pages, total }) => {
      state.coursePagination = { pages, total }
    },
    [MUTATION_TYPE.setSubsection]: (state, subsection) => {
      state.subsection = subsection
      state.subSectionHashes[subsection.id] = subsection.hashId
    },
    [MUTATION_TYPE.setMarksForCourse]: (state, marks) => {
      state.marks = marks
    },
    [MUTATION_TYPE.pushCourses]: (state, courses) => {
      const courseIds = {}
      state.courses.forEach((course) => {
        courseIds[course.id] = 1
      })
      courses.forEach((course) => {
        if (!(course.id in courseIds)) {
          state.courses.push(course)
        }
      })
    },
    [MUTATION_TYPE.updateCourseTopicTitle]: (
      state,
      { internalId, newTitle },
    ) => {
      state.courseContent.topics[internalId].title = newTitle
    },
    [MUTATION_TYPE.moveCourseSection]: (state, { internalId, direction }) => {
      const newIndex = internalId + (direction === 'up' ? -1 : 1)
      arrayMove(state.courseContent.topics, internalId, newIndex)
    },
    [MUTATION_TYPE.deleteCourseTopic]: (state, internalId) => {
      const toRemove = state.courseContent.topics.splice(internalId, 1)[0]
      if (!toRemove.isAdded) {
        state.courseChanges.topicsToDelete.push(toRemove.id)
      }
    },
    [MUTATION_TYPE.updateCourseSectionTitle]: (
      state,
      { topicInternalId, sectionInternalId, newTitle },
    ) => {
      state.courseContent.topics[topicInternalId].sections[
        sectionInternalId
      ].title = newTitle
    },
    [MUTATION_TYPE.deleteCourseSection]: (
      state,
      { topicInternalId, sectionInternalId },
    ) => {
      const toRemove = state.courseContent.topics[
        topicInternalId
      ].sections.splice(sectionInternalId, 1)[0]
      if (!toRemove.isAdded) {
        state.courseChanges.sectionsToDelete.push(toRemove.id)
      }
    },
    [MUTATION_TYPE.clearCourseChanges]: (state) => {
      state.courseChanges = {
        topicsToDelete: [],
        sectionsToDelete: [],
        subsectionsToDelete: []
      }
    },
    [MUTATION_TYPE.addTopic]: (state) => {
      const newTopic = {
        id: getTemporaryId(),
        isAdded: true,
        position: 0,
        sections: [],
        title: `Тема ${state.courseContent.topics.length}`
      }
      state.courseContent.topics.splice(0, 0, newTopic)
    },
    [MUTATION_TYPE.addSection]: (state, internalId) => {
      const newElement = {
        id: getTemporaryId(),
        isAdded: true,
        position: 0,
        title: `Раздел ${state.courseContent.topics[internalId].sections
          .length + 1}`,
        subSections: [
          {
            isAdded: true,
            position: 0,
            title: 'Новый подраздел',
            type: 'text-info',
            isSelfTest: true
          }
        ]
      }
      state.courseContent.topics[internalId].sections.push(newElement)
    },
    [MUTATION_TYPE.setCourseAvatar]: (state, file) => {
      state.courseContent.contentObject.avatar = file.id
      state.courseContent.contentObject.avatarFile = file
    },
    [MUTATION_TYPE.deleteCourseAvatar]: (state) => {
      state.courseContent.contentObject.avatar = null
      state.courseContent.courseContent.avatarFile = null
    },
    [MUTATION_TYPE.setCoursePositions]: (state) => {
      EducationApi.setCoursePositions(state.courseContent)
    },
    [MUTATION_TYPE.setTestPositions]: (state) => {
      EducationApi.setCoursePositions(state.testContent)
    },
    [MUTATION_TYPE.deleteCourseSubsection]: (
      state,
      { topicInternalId, sectionInternalId, subSectionInternalId },
    ) => {
      state.courseContent.topics[topicInternalId].sections[
        sectionInternalId
      ].subSections.splice(subSectionInternalId, 1)
    },
    [MUTATION_TYPE.addCourseSubsection]: (
      state,
      { topicInternalId, sectionInternalId, type },
    ) => {
      const section = state.courseContent.topics[topicInternalId].sections[sectionInternalId]
      const newSection = {
        isSelfTest: !type.includes('test'),
        isAdded: true,
        type,
        title: `Подраздел ${section.subSections.length}`,
        sectionId: section.id,
        position: section.subSections.length
      }
      section.subSections.push(newSection)
    },
    [MUTATION_TYPE.setSubsectionTitle]: (state, title) => {
      state.subsection.title = title
    },
    [MUTATION_TYPE.setSubsectionAnswer]: (state, answers) => {
      if (!state.subsection.qstruct) {
        state.subsection.qstruct = {}
      }
      state.subsection.qstruct.answer = answers
    },
    [MUTATION_TYPE.setSubsectionText]: (state, text) => {
      state.subsection.text = text
    },
    [MUTATION_TYPE.addSubsectionTextTestVariant]: (state, variant) => {
      if (!state.subsection.qstruct) {
        state.subsection.qstruct = {}
      }
      if (!state.subsection.qstruct.variants) {
        state.subsection.qstruct.variants = []
      }
      state.subsection.qstruct.variants.push(variant)
      state.variants = state.subsection.qstruct.variants
    },
    [MUTATION_TYPE.deleteSubsectionTextTestVariant]: (state, index) => {
      state.subsection.qstruct.variants.splice(index, 1)
      state.variants = state.subsection.qstruct.variants
    },
    [MUTATION_TYPE.setSubsectionTextTestVariant]: (state, variant) => {
      state.subsection.qstruct.variants[variant.key] = variant.text
    },
    [MUTATION_TYPE.setSubSectionIsSelfTest]: (state, isSelfTest) => {
      if (isSelfTest !== undefined) {
        state.subsection.isSelfTest = isSelfTest
      }
      state.courseContent.topics[state.subsectionIds.topicInternalId].sections[
        state.subsectionIds.sectionInternalId
      ].subSections[state.subsectionIds.subsectionInternalId]
        .isSelfTest = state.subsection.isSelfTest
    },
    [MUTATION_TYPE.setSubsectionInternalIds]: (state) => {
      // eslint-disable-next-line arrow-body-style
      state.courseContent.topics.some((topic, topicInternalId) => {
        // eslint-disable-next-line arrow-body-style
        return topic.sections.some((section, sectionInternalId) => {
          return (
            section.subSections
            && section.subSections.some((subSection, subsectionInternalId) => {
              if (subSection.id === state.subsection.id) {
                state.subsectionIds = {
                  topicInternalId,
                  sectionInternalId,
                  subsectionInternalId
                }
                return true
              }
              return false
            })
          )
        })
      })
    },
    [MUTATION_TYPE.setSubSectionHashes]: (state) => {
      state.courseContent.topics.forEach((topic) => {
        topic.sections.forEach((section) => {
          if (section.subSections) {
            section.subSections.forEach((subsection) => {
              state.subSectionHashes[subsection.id] = subsection.hashId
            })
          }
        })
      })
    },
    [MUTATION_TYPE.setTestSubSectionPosition]: (state) => {
      if (!state.testContent) {
        return
      }
      // eslint-disable-next-line arrow-body-style
      state.testContent.topics.some((topic) => {
        // eslint-disable-next-line arrow-body-style
        return topic.sections.some((section) => {
          return (
            section.subSections
            && section.subSections.some((subSection) => {
              if (subSection.id === state.subsection.id) {
                state.subsection.position = subSection.position
                return true
              }
              return false
            })
          )
        })
      })
    },
    [MUTATION_TYPE.setViewModeSubSectionPosition]: (state) => {
      const topic = state.courseContent.topics[state.courseContent.topics.length - 1]
      // eslint-disable-next-line arrow-body-style
      topic.sections.some((section) => {
        return (
          section.subSections
          && section.subSections.some((subSection) => {
            if (subSection.id === state.subsection.id) {
              state.subsection.position = subSection.position
              return true
            }
            return false
          })
        )
      })
    },
    [MUTATION_TYPE.clearSubSectionInfo]: (state) => {
      state.courseContent.topics.forEach((topic) => {
        topic.sections.forEach((section) => {
          // т.к. разделы с тестами могут быть пустыми
          if (section.subSections) {
            section.subSections.forEach((subSection, index, subSections) => {
              if (!subSection.isAdded) {
                subSections[index] = {
                  id: subSection.id,
                  position: subSection.position,
                  hashId: subSection.hashId
                }
              }
            })
          }
        })
      })
    },
    [MUTATION_TYPE.clearTemporaryIds]: (state) => {
      state.courseContent.topics.forEach((topic) => {
        if (topic.isAdded) {
          delete topic.id
        }
        topic.sections.forEach((section) => {
          if (section.isAdded) {
            delete section.id
          }
          // т.к. разделы с тестами могут быть пустыми
          if (section.subSections) {
            section.subSections.forEach((subSection) => {
              if (subSection.isAdded) {
                delete subSection.id
              }
            })
          }
        })
      })
    },
    [MUTATION_TYPE.setTestCreationMode]: (state, testCreation) => {
      if (testCreation === false) {
        state.newTestTasks = []
      }
      state.isTestCreationMode = testCreation
    },
    [MUTATION_TYPE.setTestContent]: (state, testContent) => {
      state.testContent = testContent
    },
    [MUTATION_TYPE.pushTaskToTest]: (state, { testId, task }) => {
      // добавляем новое тестовое задание в контент курса(в соответствующий тест)
      state.courseContent.topics[state.courseContent.topics.length - 1].sections
        .filter((s) => s.id === testId)[0]
        .subSections.push(task)
    },
    [MUTATION_TYPE.removeTaskFromTest]: (state, { testId, taskId }) => {
      state.courseContent.topics[
        state.courseContent.topics.length - 1
      ].sections.filter(
        (s) => s.id === testId,
      )[0].subSections = state.courseContent.topics[
        state.courseContent.topics.length - 1
      ].sections
        .filter((s) => s.id === testId)[0]
        .subSections.filter((ss) => ss.id !== Number(taskId))
    },
    [MUTATION_TYPE.prepareCourseTestPositions]: (state) => {
      state.courseContent.topics[
        state.courseContent.topics.length - 1
      ].sections.forEach((test) => {
        if (test.subSections) {
          TestApi.shuffle(test.subSections)
          test.subSections.forEach((subSection, index) => {
            subSection.position = index
          })
        }
      })
    },
    [MUTATION_TYPE.addTestSubSectionsToCourse]: (state, fetchedTest) => {
      state.courseContent.topics[
        state.courseContent.topics.length - 1
      ].sections.forEach((test, index, testArr) => {
        if (fetchedTest.id === test.id) {
          testArr[index] = fetchedTest
        }
      })
    },
    [MUTATION_TYPE.setSubSectionPassed]: (
      state,
      { courseId, subSectionId },
    ) => {
      state.courseContent.userCourses.some((course) => {
        if (course.courseId === courseId) {
          course.progress[subSectionId] = true
        }
        return false
      })
    }
  },

  actions: {
    // all content
    [ACTION_TYPE.fetchCoursesList]: async (context, pages) => {
      const response = await EducationApi.getCoursesList(
        pages.perPage,
        pages.pageNumber,
        pages.filters,
        pages.sorting,
      )
      if (pages.pageNumber > 1) {
        context.commit('pushCourses', response.data.docs)
      } else {
        context.commit('setCourses', response.data.docs)
      }
      context.commit('setCoursesPagination', {
        total: response.data.total,
        pages: response.data.pages
      })
    },
    [ACTION_TYPE.fetchScormCoursesList]: async (context) => {
      const response = await EducationApi.getScormCoursesList()
      context.commit('setScormCourses', response.data)
    },
    [ACTION_TYPE.clearCourseContent]: (context) => {
      context.commit('clearCourseContent')
      context.commit('test/clearTestContent', null, { root: true })
      context.commit('content/clearContent', null, { root: true })
    },
    [ACTION_TYPE.addNewFileToSubsection]: async (context, files) => {
      context.commit('addFileToSubsection', files[0])
      context.dispatch('contentManager/updateUpdater', null, { root: true })
    },
    [ACTION_TYPE.addCourse]: async () => {
      await EducationApi.addCourse()
    },
    [ACTION_TYPE.fetchCourseContent]: async (context, { id, all }) => {
      if (all === undefined) {
        all = context.rootGetters['currentUser/hasRole']('content-manager')
          || context.rootGetters['currentUser/hasRole'](
            'verification-specialist',
          )
          || context.rootGetters['currentUser/hasRole']('classroom-teacher')
      }
      const response = await EducationApi.getCourseContent(id, all)
      context.commit('setCourseContent', response.data)
      context.commit(
        'content/setContentData',
        {
          contentObject: response.data.contentObject
        },
        { root: true },
      )
      const currentUser = context.rootGetters['currentUser/getCurrentUser']
      if (currentUser) {
        context.commit(
          'sortTests',
          currentUser.organizationId
        )
      }
      context.commit('prepareCourseTestPositions')
      context.commit('setSubSectionHashes')
      context.dispatch('fetchCourseProgress', id)
    },
    [ACTION_TYPE.fetchSubsection]: async (context, id) => {
      const hash = context.getters.getSubSectionHash(id)
      const response = await EducationApi.getSubsectionOfCourse(
        context.getters.getCourseContent.id,
        id,
        hash,
      )
      context.commit('setSubsection', response.data)
      if (context.getters.getCourseMember) {
        context.dispatch('sendSubSectionProgress', {
          subsection: response.data,
          id
        })
      }
      context.commit('setSubsectionInternalIds')
      context.dispatch('setSubSectionPosition')
    },
    [ACTION_TYPE.sendSubSectionProgress]: async (
      context,
      { subsection, id },
    ) => {
      if (subsection && subsection.type && subsection.type.includes('info')) {
        context.dispatch('sendAnswer', {
          courseId: context.getters.getCourseContent.id,
          subsectionId: id,
          answer: '',
          type: 'info'
        })
        context.commit('setSubSectionPassed', {
          courseId: context.getters.getCourseContent.id,
          subSectionId: id
        })
        context.dispatch(
          'fetchCourseProgress',
          context.getters.getCourseContent.id,
        )
      }
    },
    [ACTION_TYPE.updateSubsection]: async (context, courseId) => {
      const response = await EducationApi.updateCourseSubsection(
        courseId,
        context.getters.getSubsection,
      )
      context.commit('setSubsection', response.data)
      if (context.getters.getCourseMember) {
        context.dispatch('sendSubSectionProgress', {
          subsection: response.data,
          id: response.data.id
        })
      }
      context.commit('setSubsectionInternalIds')
      context.dispatch('setSubSectionPosition')
      context.commit('setSubSectionIsSelfTest')
    },
    [ACTION_TYPE.deleteCourse]: async (context, id) => {
      await EducationApi.deleteCourse(id)
      context.commit('clearCourseContent')
    },

    [ACTION_TYPE.updateCourse]: async (context, courseId) => {
      context.commit('setCoursePositions')
      context.commit('clearSubSectionInfo')
      context.commit('clearTemporaryIds')
      context.commit('updateCourseStatus')
      await Promise.all([
        EducationApi.updateCourseInfo(
          courseId,
          context.getters.getCourseContent.contentObject,
        ),
        EducationApi.updateCourseContent(
          courseId,
          context.getters.getCourseContent.topics,
        )
      ])
      // context.dispatch('fetchCourseContent', { id: courseId })
    },
    [ACTION_TYPE.applyCourseChanges]: async (context) => {
      const promises = []
      const courseId = context.state.courseContent.id
      context.state.courseChanges.sectionsToDelete.forEach((id) => {
        promises.push(EducationApi.deleteCourseSection(courseId, id))
      })

      context.state.courseChanges.topicsToDelete.forEach((id) => {
        promises.push(EducationApi.deleteCourseTopic(courseId, id))
      })
      if (promises.length > 0) {
        await Promise.all(promises)
        context.commit('clearCourseChanges')
      }
    },
    [ACTION_TYPE.deleteSubsection]: async (
      context,
      { topicInternalId, sectionInternalId, subSectionInternalId },
    ) => {
      const subSectionId = context.state.subsection.id
      context.commit('deleteCourseSubsection', {
        topicInternalId,
        sectionInternalId,
        subSectionInternalId
      })
      const courseId = context.state.courseContent.id
      await EducationApi.deleteCourseSubSection(courseId, subSectionId)
      context.commit('setCoursePositions')
      context.commit('clearSubSectionInfo')
      await EducationApi.updateCourseContent(
        courseId,
        context.getters.getCourseContent.topics,
      )
    },
    [ACTION_TYPE.fetchContentForNewTest]: async (context, courseId) => {
      const response = await TestApi.getContentForTest(courseId)
      context.commit('setTestContent', response.data)
      context.commit('setTestPositions')
      context.commit(
        'content/setContentData',
        {
          contentObject: response.data.contentObject
        },
        { root: true },
      )
    },
    [ACTION_TYPE.addTextTestVariant]: async (context, variant) => {
      context.commit('addSubsectionTextTestVariant', variant)
    },
    [ACTION_TYPE.deleteTextTestVariant]: async (context, index) => {
      context.commit('deleteSubsectionTextTestVariant', index)
    },
    [ACTION_TYPE.pushTaskToTest]: async (context, payload) => {
      context.commit('pushTaskToTest', payload)
      context.commit('setCoursePositions')
      context.dispatch('setSubSectionPosition')
    },
    [ACTION_TYPE.removeTaskFromTest]: async (context, task) => {
      context.commit('removeTaskFromTest', task)
      context.commit('setCoursePositions')
      context.dispatch('setSubSectionPosition')
    },
    [ACTION_TYPE.fetchCourseProgress]: async (context) => {
      let passedSubSections = 0
      let allSubSections = 0
      const content = context.getters.getCourseContent
      if (
        content
        && content.isSCORM
        && Array.isArray(content.userCourses)
        && content.userCourses.length > 0
      ) {
        const attempts = (await EducationApi.getScormAttempts(content.id)).data
        if (
          Array.isArray(attempts) && attempts.length > 0
          && attempts[0].passed === true
        ) {
          context.commit('setCourseProgress', 100)
        } else {
          context.commit('setCourseProgress', 0)
        }
      }
      if (content && content.userCourses && !content.isSCORM && content.userCourses.length) {
        content.topics.forEach((topic) => {
          if (topic.title !== 'Тестирование') {
            topic.sections.forEach((section) => {
              allSubSections += section.subSections.length
              section.subSections.forEach((subsection) => {
                if (
                  subsection.id in content.userCourses[0].progress
                  && content.userCourses[0].progress[subsection.id]
                ) {
                  passedSubSections += 1
                }
              })
            })
          }
        })
      }
      context.commit(
        'setCourseProgress',
        Math.round((passedSubSections / allSubSections) * 100),
      )
    },
    [ACTION_TYPE.sendAnswer]: async (context, payload) => {
      const response = await EducationApi.checkAnswerOnQuestion(
        payload.courseId,
        payload.subsectionId,
        payload.answer,
        payload.type,
      )
      if (response.data && payload.type === 'test') {
        let message = 'Задание решено не верно! Попробуйте ещё раз.'
        if (response.data.isCorrect) {
          message = 'Задание выполнено успешно!'
          context.commit('setSubSectionPassed', {
            courseId: Number(payload.courseId),
            subSectionId: Number(payload.subsectionId)
          })
          context.dispatch('fetchCourseProgress', payload.courseId)
        }
        context.dispatch(
          'toasts/pushToasts',
          {
            title: 'Уведомление',
            error: !response.data.isCorrect,
            message,
            time: 4
          },
          { root: true },
        )
      }
    },
    [ACTION_TYPE.applyOnCourse]: async (context) => {
      await EducationApi.applyOnCourse(context.state.courseContent.id)
      context.dispatch('fetchCourseContent', {
        id: context.state.courseContent.id
      })
    },
    [ACTION_TYPE.sendSCORMResult]: async (context, { courseId, scoreRaw }) => {
      await TestApi.sendSCORMTestResults(courseId, scoreRaw)
      context.dispatch('fetchCourseProgress', courseId)
    },
    [ACTION_TYPE.fetchMarksForCourse]: async (context, { courseId, userId }) => {
      const response = await EducationApi.getMarksForTests(courseId, userId)
      context.commit('setMarksForCourse', response.data)
    },
    [ACTION_TYPE.setSubSectionPosition]: async (context) => {
      if (context.rootGetters['test/isTestCreationMode']) {
        if (context.rootGetters['test/isTestViewMode']) {
          context.commit('setViewModeSubSectionPosition')
        } else {
          context.commit('setTestSubSectionPosition')
        }
      } else if (
        context.rootGetters['test/isTestingMode']
        || context.rootGetters['test/isTestViewMode']
        || context.rootGetters['educationStudentsManagement/getTestReviewMode']
      ) {
        context.commit('setViewModeSubSectionPosition')
      }
    }
  },

  getters: {
    // single content info page
    [GETTER_TYPE.getCourses]: (state) => state.courses,
    [GETTER_TYPE.getScormCourses]: (state) => state.scormCourses,
    [GETTER_TYPE.getMarksForCourse]: (state) => state.marks,
    [GETTER_TYPE.getSubsection]: (state) => {
      if (
        state.subsection
        && state.subsection.qstruct
        && state.subsection.qstruct.variants
      ) {
        state.variants = state.subsection.qstruct.variants
      } else {
        state.variants = []
      }
      return state.subsection
    },
    [GETTER_TYPE.getCourseContent]: (state) => state.courseContent,
    // eslint-disable-next-line arrow-body-style, no-unused-vars
    [GETTER_TYPE.getSectionElementPassed]: (state) => (
      topicInternalId,
      sectionInternalId,
    ) => {
      let passed = 0
      if (
        state.courseContent
        && state.courseContent.userCourses
        && state.courseContent.userCourses.length
      ) {
        state.courseContent.topics[topicInternalId].sections[
          sectionInternalId
        ].subSections.forEach((subsection) => {
          if (
            subsection.id in state.courseContent.userCourses[0].progress
            && state.courseContent.userCourses[0].progress[subsection.id]
          ) {
            passed += 1
          }
        })
      }
      return passed
    },
    [GETTER_TYPE.isTestCreationMode]: (state) => state.isTestCreationMode,
    [GETTER_TYPE.getVariantsForTest]: (state) => state.variants,
    [GETTER_TYPE.getNewTestTasks]: (state) => state.newTestTasks,
    [GETTER_TYPE.getCoursesPagination]: (state) => state.coursePagination,
    [GETTER_TYPE.getTopicNames]: (state) => {
      const names = []
      if (state.courseContent) {
        state.courseContent.topics.forEach((topic) => {
          names.push(topic.title)
        })
      }
      return names
    },
    [GETTER_TYPE.getSectionNames]: (state) => (topicInternalId) => {
      const names = []
      if (state.courseContent) {
        state.courseContent.topics[topicInternalId].sections.forEach(
          (section) => {
            names.push(section.title)
          },
        )
      }
      return names
    },
    [GETTER_TYPE.getTestContent]: (state) => state.testContent,
    [GETTER_TYPE.getCourseProgress]: (state) => state.progress,
    [GETTER_TYPE.getCourseMember]: (state) => {
      if (state.courseContent && state.courseContent.userCourses) {
        return state.courseContent.userCourses.some(
          (userCourse) => userCourse.courseId === state.courseContent.id,
        )
      }
      return false
    },
    [GETTER_TYPE.getCourseSubsectionsStructure]: (state) => state.courseSubsectionsStructure,
    [GETTER_TYPE.getSubSectionHash]: (state) => (id) => state.subSectionHashes[id]
  }
}
